export const rafPasses = () => {
  return new Promise<void>((resolve) => requestAnimationFrame(() => resolve()))
}